// stores/userVariables.ts
import { defineStore } from 'pinia';
import axiosInstance from '../plugins/axios';

interface LanguageData {
  [key: string]: string;
}

interface EnabledLanguage {
  languageCode: string;
  translation: LanguageData;
}

export const useUserVariablesStore = defineStore('userVariables', {
  state: () => ({
    currentLanguage: '', 
    languageData: {} as Record<string, LanguageData>, 
  }),

  actions: {
    setLanguage(language: string) {
      this.currentLanguage = language;
    },

    async loadLanguageData() {
      try {
        const res = await axiosInstance.get('/config/languages');
        const { eL } = res.data;

        if (eL) {
          eL.forEach((lang: EnabledLanguage) => {
            this.languageData[lang.languageCode] = lang.translation;
          });
        }
      } catch (error) {
        console.error('Fehler beim Laden der Sprachdaten:', error);
      }
    },
  },

  getters: {
    currentLanguageData(state): LanguageData | undefined {
      return state.languageData[state.currentLanguage];
    },

    // Neuer Getter, der ein Array aller languageCodes zurückgibt
    allLanguageCodes(state): string[] {
      return Object.values(state.languageData).map((lang) => lang.languageCode);
    },
  },
});
